import { render, staticRenderFns } from "./MockBirdsEye.vue?vue&type=template&id=bff7eca4&scoped=true"
import script from "./MockBirdsEye.vue?vue&type=script&lang=js"
export * from "./MockBirdsEye.vue?vue&type=script&lang=js"
import style0 from "./MockBirdsEye.vue?vue&type=style&index=0&id=bff7eca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff7eca4",
  null
  
)

export default component.exports